import * as React from "react";
import classnames from "classnames";
import { Heading } from "@grandvisionhq/elements";
import { Icon } from "@grandvisionhq/icons";
import AppointmentPriceContainer from "../../../../AppointmentPrice/v3/components/AppointmentPrice/AppointmentPriceContainer.js";
import { AppointmentTypeToolTipContainer } from "../../../AppointmentTypeToolTip/v3/components/AppointmentTypeButton/AppointmentTypeToolTip/AppointmentTypeToolTipContainer.js";
/* empty css                           */
const AppointmentTypeButton = ({
  className,
  icon,
  labels,
  toolTip,
  price,
  onClickToolTip,
  ...rest
}) => /* @__PURE__ */ React.createElement("div", { className: "appointment-type-wrapper" }, /* @__PURE__ */ React.createElement("button", { ...rest, className: classnames("appointment-type-button", className) }, icon && /* @__PURE__ */ React.createElement("span", { className: "appointment-type-button__icon" }, /* @__PURE__ */ React.createElement(Icon, { name: icon, width: 32, height: 32, viewBox: "0 0 24 24" })), /* @__PURE__ */ React.createElement("span", { className: "appointment-type-button__text" }, /* @__PURE__ */ React.createElement(Heading, { className: "appointment-type-button__name", variant: "subheading1", component: "h3" }, labels.name), labels.description && /* @__PURE__ */ React.createElement("span", { className: "appointment-type-button__description" }, labels.description), price && /* @__PURE__ */ React.createElement(AppointmentPriceContainer, { ...price }))), toolTip && onClickToolTip && /* @__PURE__ */ React.createElement(
  AppointmentTypeToolTipContainer,
  {
    onClick: onClickToolTip,
    "aria-label": toolTip.title,
    className: "appointment-type-tooltip-wrapper"
  }
));
export {
  AppointmentTypeButton as default
};
//# sourceMappingURL=AppointmentTypeButton.js.map
